module.exports = __webpack_public_path__ + "img/dsci0023.d2b928cf.jpg";